import React from "react";
import { NnwClientModel } from "../../../../helpers/nnwClient";
import { observer } from "mobx-react";
import { Checkbox } from "@material-ui/core";
import Notification from "../../../sharedComponents/notification/notification";
import { ErrorMessages } from "../../../../helpers/errorMessage";
import { PeselUtility } from "../../../../helpers/peselUtility";
import { runInAction } from "mobx";

interface HeartAttackAndStrokeProps {
    client: NnwClientModel;
}

export function HeartAttackAndStroke(props: HeartAttackAndStrokeProps) {
    return (
        <div>
            <div className="heart-attack-and-stroke">
                <div className="question-answer-container">
                    <div className="question">Rozszerzenie zawał i udar</div>
                    {renderHeartAttackAndStrokeCheckBox()}

                </div>
            </div>
        </div>
    );

    function renderHeartAttackAndStrokeCheckBox() {
        const value = props.client.heartAttackAndStroke;

        return (
            <div className="heart-attack-and-stroke-container">
                <div className="heart-attack-and-stroke-checkbox">
                    <Checkbox
                        checked={value}
                        onChange={(event) => {
                            setHeartAndStroke(event.target.checked);
                        }}
                    />
                </div>
                <div className={"checkbox-error"} >
                    {shouldRenderError() && <Notification type="error" message={ErrorMessages.nnw.ageOver60} />}
                </div>
            </div>
        );
    }

    function shouldRenderError() {
        const isPeselValid = props.client.pesel.errorMessage === "" && props.client.pesel.value?.length === PeselUtility.PESEL_LENGTH;
        const isClientAgeOver60 = PeselUtility.isAgeOver60FromPesel(props.client.pesel.value!);
        const isHeartAttackAndStrokeSelectedForClient = props.client.heartAttackAndStroke;

        return isPeselValid && isClientAgeOver60 && isHeartAttackAndStrokeSelectedForClient;
    }

    function setHeartAndStroke(value: boolean) {
        runInAction(() => {
            // TODO: create setter and remove 'runInAction'
            props.client.heartAttackAndStroke = value;
        });
    }
}
export default (observer(HeartAttackAndStroke));
